"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepartmentsEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const DepartmentsDto_1 = require("./DepartmentsDto");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class DepartmentsEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, departments) {
        super();
        this._requiredFieldsSetStatus = {
            locationId: false,
            name: false,
            hours: false,
            phoneNumber: false,
            emailAddress: false,
            emailFormat: false,
            websiteUrl: false,
            departmentType: false,
            customImageFileName: false,
            customImageContentType: false,
            customImageFileSize: false,
            customImageUpdatedAt: false,
            address: false,
            phoneFieldText: false,
            messageFieldText: false,
            extra1Name: false,
            extra1Url: false,
            extra2Name: false,
            extra2Url: false,
            extra3Name: false,
            extra3Url: false,
            formUrl: false,
            serviceTypes: false,
            hideTitleOverlay: false
        };
        this._dependencies = dependencies;
        if (departments === undefined) {
            this._dto = new DepartmentsDto_1.DepartmentsDto();
        }
        else if (departments instanceof DepartmentsDto_1.DepartmentsDto) {
            this._dto = new DepartmentsDto_1.DepartmentsDto(departments);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (departments instanceof DepartmentsEntity) {
            this._dto = new DepartmentsDto_1.DepartmentsDto(departments._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new DepartmentsDto_1.DepartmentsDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getLocationId() {
        return this._dto.locationId;
    }
    setLocationId(untrustedValue) {
        let _untrustedValue;
        this.clearError("locationId");
        this._requiredFieldsSetStatus.locationId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.locationId) {
            return;
        }
        this._dto.locationId = _untrustedValue;
        this._setIsDirty(true);
    }
    getImageId() {
        return this._dto.imageId;
    }
    setImageId(untrustedValue) {
        let _untrustedValue;
        this.clearError("imageId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("imageId", "Image Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.imageId) {
            return;
        }
        this._dto.imageId = _untrustedValue;
        this._setIsDirty(true);
    }
    getName() {
        return this._dto.name;
    }
    setName(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("name");
        this._requiredFieldsSetStatus.name = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("name", "Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("name", `Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.name) {
            return;
        }
        this._dto.name = _untrustedValue;
        this._setIsDirty(true);
    }
    getHours() {
        return this._dto.hours;
    }
    setHours(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("hours");
        this._requiredFieldsSetStatus.hours = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("hours", "Hours is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("hours", `Hours has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.hours) {
            return;
        }
        this._dto.hours = _untrustedValue;
        this._setIsDirty(true);
    }
    getPhoneNumber() {
        return this._dto.phoneNumber;
    }
    setPhoneNumber(untrustedValue) {
        const maxLength = 30;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("phoneNumber");
        this._requiredFieldsSetStatus.phoneNumber = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("phoneNumber", "Phone Number is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("phoneNumber", `Phone Number has exceeded the maximum length (${maxLength} chr).`));
        }
        else if (!validators_1.isMobilePhone(_untrustedValue, ["en-US", "en-CA"])) {
            this.addError(new ValidationError_1.ValidationError("phone", "Phone is invalid."));
        }
        if (!this.isNew && _untrustedValue === this._dto.phoneNumber) {
            return;
        }
        this._dto.phoneNumber = _untrustedValue;
        this._setIsDirty(true);
    }
    getEmailAddress() {
        return this._dto.emailAddress;
    }
    setEmailAddress(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("emailAddress");
        this._requiredFieldsSetStatus.emailAddress = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("emailAddress", "Email Address is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("emailAddress", `Email Address has exceeded the maximum length (${maxLength} chr).`));
        }
        else if (!validators_1.isEmail(_untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("emailAddress", "Email Address is invalid."));
        }
        if (!this.isNew && _untrustedValue === this._dto.emailAddress) {
            return;
        }
        this._dto.emailAddress = _untrustedValue;
        this._setIsDirty(true);
    }
    getEmailFormat() {
        return this._dto.emailFormat;
    }
    setEmailFormat(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("emailFormat");
        this._requiredFieldsSetStatus.emailFormat = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("emailFormat", "Email Format is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("emailFormat", `Email Format has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.emailFormat) {
            return;
        }
        this._dto.emailFormat = _untrustedValue;
        this._setIsDirty(true);
    }
    getWebsiteUrl() {
        return this._dto.websiteUrl;
    }
    setWebsiteUrl(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("websiteUrl");
        this._requiredFieldsSetStatus.websiteUrl = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("websiteUrl", "Website URL is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("websiteUrl", `Website URL has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.websiteUrl) {
            return;
        }
        this._dto.websiteUrl = _untrustedValue;
        this._setIsDirty(true);
    }
    getDepartmentType() {
        return this._dto.departmentType;
    }
    setDepartmentType(untrustedValue) {
        const maxLength = 11;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("departmentType");
        this._requiredFieldsSetStatus.departmentType = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("departmentType", "Department Type is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("departmentType", `Department Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.departmentType) {
            return;
        }
        this._dto.departmentType = _untrustedValue;
        this._setIsDirty(true);
    }
    getCustomImageContentType() {
        return this._dto.customImageContentType;
    }
    setCustomImageContentType(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("customImageContentType");
        this._requiredFieldsSetStatus.customImageContentType = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("customImageContentType", "Custom Image Content Type is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("customImageContentType", "Custom Image Content Type has exceeded " +
                `the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.customImageContentType) {
            return;
        }
        this._dto.customImageContentType = _untrustedValue;
        this._setIsDirty(true);
    }
    getCustomImageFileSize() {
        return this._dto.customImageFileSize;
    }
    setCustomImageFileSize(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("customImageFileSize");
        this._requiredFieldsSetStatus.customImageFileSize = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("customImageFileSize", "Custom Image File Size is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("customImageFileSize", "Custom Image File Size has exceeded " +
                `the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.customImageFileSize) {
            return;
        }
        this._dto.customImageFileSize = _untrustedValue;
        this._setIsDirty(true);
    }
    getCustomImageFileName() {
        return this._dto.customImageFileName;
    }
    setCustomImageFileName(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("customImageFileName");
        this._requiredFieldsSetStatus.customImageFileName = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("customImageFileName", "Custom Image File Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("customImageFileName", "Custom Image File Name has exceeded " +
                `the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.customImageFileName) {
            return;
        }
        this._dto.customImageFileName = _untrustedValue;
        this._setIsDirty(true);
    }
    getCustomImageUpdatedAt() {
        return this._dto.customImageUpdatedAt;
    }
    setCustomImageUpdatedAt(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("customImageUpdatedAt");
        this._requiredFieldsSetStatus.customImageUpdatedAt = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("customImageUpdatedAt", "Custom Image Updated At is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("customImageUpdatedAt", "Custom Image Updated At has exceeded " +
                `the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.customImageUpdatedAt) {
            return;
        }
        this._dto.customImageUpdatedAt = _untrustedValue;
        this._setIsDirty(true);
    }
    getAddress() {
        return this._dto.address;
    }
    setAddress(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("address");
        this._requiredFieldsSetStatus.address = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("address", "Address is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("address", `Address has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.address) {
            return;
        }
        this._dto.address = _untrustedValue;
        this._setIsDirty(true);
    }
    getPhoneFieldText() {
        return this._dto.phoneFieldText;
    }
    setPhoneFieldText(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("phoneFieldText");
        this._requiredFieldsSetStatus.phoneFieldText = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("phoneFieldText", "Phone Field Text is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("phoneFieldText", `Phone Field Text has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.phoneFieldText) {
            return;
        }
        this._dto.phoneFieldText = _untrustedValue;
        this._setIsDirty(true);
    }
    getMessageFieldText() {
        return this._dto.messageFieldText;
    }
    setMessageFieldText(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("messageFieldText");
        this._requiredFieldsSetStatus.messageFieldText = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("messageFieldText", "Message Field Text is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("messageFieldText", `Message Field Text has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.messageFieldText) {
            return;
        }
        this._dto.messageFieldText = _untrustedValue;
        this._setIsDirty(true);
    }
    getExtra1Name() {
        return this._dto.extra1Name;
    }
    setExtra1Name(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("extra1Name");
        this._requiredFieldsSetStatus.extra1Name = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("extra1Name", "Extra 1 Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("extra1Name", `Extra 1 Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.extra1Name) {
            return;
        }
        this._dto.extra1Name = _untrustedValue;
        this._setIsDirty(true);
    }
    getExtra1Url() {
        return this._dto.extra1Url;
    }
    setExtra1Url(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("extra1Url");
        this._requiredFieldsSetStatus.extra1Url = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("extra1Url", "Extra 1 URL is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("extra1Url", `Extra 1 URL has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.extra1Url) {
            return;
        }
        this._dto.extra1Url = _untrustedValue;
        this._setIsDirty(true);
    }
    getExtra2Name() {
        return this._dto.extra2Name;
    }
    setExtra2Name(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("extra2Name");
        this._requiredFieldsSetStatus.extra2Name = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("extra2Name", "Extra 2 Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("extra2Name", `Extra 2 Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.extra2Name) {
            return;
        }
        this._dto.extra2Name = _untrustedValue;
        this._setIsDirty(true);
    }
    getExtra2Url() {
        return this._dto.extra2Url;
    }
    setExtra2Url(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("extra2Url");
        this._requiredFieldsSetStatus.extra2Url = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("extra2Url", "Extra 2 URL is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("extra2Url", `Extra 2 URL has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.extra2Url) {
            return;
        }
        this._dto.extra2Url = _untrustedValue;
        this._setIsDirty(true);
    }
    getExtra3Name() {
        return this._dto.extra3Name;
    }
    setExtra3Name(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("extra3Name");
        this._requiredFieldsSetStatus.extra3Name = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("extra3Name", "Extra 3 Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("extra3Name", `Extra 3 Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.extra3Name) {
            return;
        }
        this._dto.extra3Name = _untrustedValue;
        this._setIsDirty(true);
    }
    getExtra3Url() {
        return this._dto.extra3Url;
    }
    setExtra3Url(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("extra3Url");
        this._requiredFieldsSetStatus.extra3Url = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("extra3Url", "Extra 3 URL is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("extra3Url", `Extra 3 URL has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.extra3Url) {
            return;
        }
        this._dto.extra3Url = _untrustedValue;
        this._setIsDirty(true);
    }
    getFormUrl() {
        return this._dto.formUrl;
    }
    setFormUrl(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("formUrl");
        this._requiredFieldsSetStatus.formUrl = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("formUrl", "Form URL is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("formUrl", `Form URL has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.formUrl) {
            return;
        }
        this._dto.formUrl = _untrustedValue;
        this._setIsDirty(true);
    }
    getServiceTypes() {
        return this._dto.serviceTypes;
    }
    setServiceTypes(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("serviceTypes");
        this._requiredFieldsSetStatus.serviceTypes = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("serviceTypes", "Service Types is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("serviceTypes", `Service Types has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.serviceTypes) {
            return;
        }
        this._dto.serviceTypes = _untrustedValue;
        this._setIsDirty(true);
    }
    getHideTitleOverlay() {
        return this._dto.hideTitleOverlay;
    }
    setHideTitleOverlay(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("hideTitleOverlay");
        this._requiredFieldsSetStatus.hideTitleOverlay = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("hideTitleOverlay", "Hide Title Overlay is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("hideTitleOverlay", `Hide Title Overlay has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.hideTitleOverlay) {
            return;
        }
        this._dto.hideTitleOverlay = _untrustedValue;
        this._setIsDirty(true);
    }
    loadAsync(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.departmentsDatastore
                    .getAsync(id);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Departments is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.departmentsDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.departmentsDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Customer Profile cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.departmentsDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.DepartmentsEntity = DepartmentsEntity;
//# sourceMappingURL=DepartmentsEntity.js.map